import { NgxGpAutocompleteDirective } from '@angular-magic/ngx-gp-autocomplete';
import { Component, ElementRef, EventEmitter, Input, NgZone, OnDestroy, OnInit, Output, ViewChild, ChangeDetectorRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MainService } from 'src/app/services/main-service.service';
import { ProposalService } from 'src/app/services/proposal/proposal.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-google-api',
  templateUrl: './google-api.component.html',
  styleUrls: ['./google-api.component.scss']
})
export class GoogleApiComponent implements OnInit, OnDestroy {

  @Output() setAddress: EventEmitter<any> = new EventEmitter();
  @Input() search_canada: any = 0;
  @Input() customClass: any = 'col';
  @Input() model: any = '';
  @Input() model1: any = '';
  @Input() disabled: any = false;
  @Input() defaultzip = {};
  @Input() t: any;
  @Input() label: any = 'Address*';
  @Input() label1: any = 'Address';
  @Input() formItem: any;
  @Input() zipcodeNull: any;
  @Input() isRequired: any = false;
  @Input() not_found = 'No Result Found';
  @Input() placeholder: any = 'Enter Zip';
  @Input() invalid_input_class: any;
  @Input() editAddressManually = false;
  @Input() addressDetails: any;
  @Input() joymindData = false;
  @ViewChild('ngxPlaces') placesRef: NgxGpAutocompleteDirective;
  @ViewChild('addressInput') addressInput: ElementRef<HTMLInputElement>;
  contractToken: any
  @Input() from_page = '';
  country_code: any;
  options1: { componentRestrictions: { country: any[]; }; fields: string[]; types: string[]; };
  show = false;
  getData: any;
  addressSelected = false;
  private pacEl: HTMLElement | null = null;
  private pacObserver: MutationObserver | null = null;

  constructor(public _mainservice: MainService,
    public proposal: ProposalService, private route: ActivatedRoute,
    private cdr: ChangeDetectorRef,
    private zone: NgZone
  ) { }

  ngOnInit(): void {
    setTimeout(() => {
      console.log(this._mainservice.currency_data.country_code, ">>>>");
      if (this._mainservice.currency_data.country_code) {
        let countries = [];
        countries.push(this._mainservice.currency_data.country_code);
        const US_UT_country_codes = ['VI', 'PR', 'GU', 'AS', 'MP']; //union territory of us
        if (this.joymindData) {
          countries.push('CA'); // adding united states minor outlying islands as per google documentation
        }
        if (this._mainservice.currency_data.country_code == 'US') {
          countries = countries.concat(US_UT_country_codes);
        } else if (this._mainservice.currency_data.country_code == 'AU') {
          countries = [];
        }
        this.options1 = {
          componentRestrictions: { country: countries },
          fields: ['address_components', 'adr_address', 'geometry', 'name', 'formatted_address'],
          types: ['address']
        }
        this.show = true;
        // Set from a timer, so nothing has marked the view tree dirty: an
        // OnPush host is skipped by the tick that follows and the input stays
        // unrendered until some unrelated event happens to dirty it.
        this.cdr.markForCheck();
      } else {
        this.proposal.getData().subscribe((data: any) => {
          this.country_code = data.doctor_country_currency_info.country.country_code;
          if(this.country_code == 'AU') {
            this.country_code = null;
          }
          if (this.country_code != '') {
            this.options1 = {
              componentRestrictions: { country: [this.country_code] },
              fields: ['address_components', 'adr_address', 'geometry', 'name', 'formatted_address'],
              types: ['address']
            }
            this.show = true;
            this.cdr.markForCheck();
          }
        });
      }
    });

  }

  /* Google appends the suggestion list (.pac-container) to <body> and keeps
   * recomputing its inline top/left in document coordinates. That math breaks
   * as soon as the form scrolls inside an inner container or a modal, and
   * device behaviour (on-screen keyboard, collapsing URL bar, in-app
   * webviews) shifts it even further. Instead of chasing coordinates, adopt
   * the list into the input's own wrapper the moment it appears: the
   * .pac-anchor CSS then pins it right under the field and it scrolls
   * together with the form, which is correct in every container on every
   * device. */
  private adoptPacContainer = () => {
    if (this.pacEl) {
      return;
    }
    const input = this.addressInput && this.addressInput.nativeElement;
    if (!input || !input.parentElement || document.activeElement !== input) {
      return;
    }
    const pacs = document.querySelectorAll('body > .pac-container');
    for (let i = 0; i < pacs.length; i++) {
      const pac = pacs[i] as HTMLElement;
      // Only the focused input's list is visible, so the visible one is ours
      // (never the pac-container of another app-google-api on the page).
      if (pac.offsetWidth > 0 || pac.offsetHeight > 0) {
        input.parentElement.classList.add('pac-anchor');
        input.parentElement.appendChild(pac);
        this.pacEl = pac;
        if (this.pacObserver) {
          this.pacObserver.disconnect();
          this.pacObserver = null;
        }
        break;
      }
    }
  };

  onAddressFocus() {
    if (this.pacEl) {
      return;
    }
    // Outside Angular so the observer does not trigger change detection.
    this.zone.runOutsideAngular(() => {
      // The list is created lazily with the first predictions; watch the
      // DOM so it is adopted the moment Google shows it.
      this.pacObserver = new MutationObserver(this.adoptPacContainer);
      this.pacObserver.observe(document.body, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['style'],
      });
    });
  }

  onAddressBlur() {
    if (this.pacObserver) {
      this.pacObserver.disconnect();
      this.pacObserver = null;
    }
  }

  ngOnDestroy(): void {
    this.onAddressBlur();
  }

  handleAddressChange(item: google.maps.places.PlaceResult) {
    this.addressSelected = true;
    if(!this.formItem && !this.zipcodeNull) {
      this.getZipCode(this.zipObjectCovert(item));
    } else {
      this.getData = this.zipObjectCovert(item);
      this.editAddressManually = false;
      this.getData['edit_address_manually'] = this.editAddressManually;
      this.setAddress.emit(this.getData);
      this.model = this.getData.formatted_address ? this.getData.formatted_address : this.getData.item.name;
    }
  }


  getZipCode(item: any) {
    this._mainservice.setLoader(true);
    this._mainservice.newApi('post', environment.request_url + 'add_address_line_two', { addressObj: item })
      .subscribe((response: any) => {
        if (!response.is_error) {
          if (response && response.data && response.data.city_id) {
            this.setAddress.emit('');
            this.setAddress.emit(response.data);
            this.model = response.data.formatted_address;
          } else {
            this.setAddress.emit(response);
          }
        } else {
          this._mainservice.customPopups(response.err || response.override_text, 1)
          console.log(response.override_text);
          this._mainservice.customPopups("Invalid Address, Try Again with Another Address", 1);}
        this._mainservice.setLoader(false);
      })
  }


  zipObjectCovert(item?: any) {
    const cityAddressHierarchy = [
      "neighborhood",
      "political",
      "sublocality",
      "sublocality_level_1",
      "sublocality_level_2",
      "sublocality_level_3",
      "sublocality_level_4",
      "sublocality_level_5",
      "locality",
      "administrative_area_level_3",
      "administrative_area_level_2",
      "postal_town",
      "colloquial_area",
    ];
    const desire_object: any = {};
    let temp: any;
    desire_object.place_id = item.place_id;
    desire_object.item = item;
    temp = item && item.address_components && item.address_components.find(inner => inner.types.includes('postal_code') || inner.types.includes('plus_code'));
    temp = temp && temp.long_name;
    desire_object.zip = temp;

    const complete_address = JSON.stringify(item.adr_address);
    const address_breakup = complete_address.split(",");
    const locality = address_breakup.filter(item => item.includes("locality"));
    if (locality && locality.length) {
      const city = locality[0].slice(locality[0].indexOf('">') + 2, locality[0].indexOf('</span>'));

      desire_object.city = city;
    } else {
      for (const type of cityAddressHierarchy) {
        // Find the first matching address component based on the current hierarchy type
        temp = item.address_components.find((comp: any) =>
          comp.types.includes(type)
        );
        if (temp) {
          // If a match is found, set the city's long name and break the loop
          desire_object.city = temp.long_name;
          break;
        }
      }
    }
    // temp = item && item.address_components && item.address_components.find(inner => inner.types.includes('locality'));
    // temp = temp || item && item.address_components && item.address_components.find(inner => inner.types.includes('administrative_area_level_2')) || item && item.address_components && item.address_components.find(inner => inner.types.includes('postal_town')) || item && item.address_components && item.address_components.find(inner => inner.types.includes('neighborhood')) || item && item.address_components && item.address_components.find(inner => inner.types.includes('administrative_area_level_3'));

    // temp = temp && temp.long_name;
    // desire_object.city = temp;

    temp = item && item.address_components && item.address_components.find(inner => inner.types.includes('administrative_area_level_1'));
    desire_object.state_name = temp && temp.long_name;
    desire_object.state_code = temp && temp.short_name;


    temp = item && item.address_components && item.address_components.find(inner => inner.types.includes('country'));
    desire_object.country_name = temp && temp.long_name;
    desire_object.country_code = temp && temp.short_name;

    if (item.geometry && item.geometry.location) {
      desire_object.latitude = item.geometry.location.lat();
      desire_object.longitude = item.geometry.location.lng();
    }
    return desire_object;
  }
  removeZipCode() {
    this.addressSelected = false;
    if (this.zipcodeNull != 'arDetailPractina') {
      return; // not removing the code for future purposes (if its ever needed)
    }
    if (!this.editAddressManually) {
      this.model = '';
      this.setAddress.emit('');
    }
  }

  handleManualAddressChange() {
    this.model = this.model?.trim();
    if (!this.getData) {
      this.editAddressManually = true;
      this.getData = {};
    }
    if (this.model) {
      if (!this.addressSelected) {
        this.getData = {};
      }
      this.getData['item'] = {
        formatted_address: this.model
      };
      this.getData['formatted_address'] = this.model;
      this.getData['edit_address_manually'] = this.editAddressManually;
      this.setAddress.emit(this.getData);
    } else {
      this.setAddress.emit('');
    }
  }

}
